import { Component, OnInit, signal } from '@angular/core';
import { AccountService } from '../authentication/services/account.service';
import { SsrStateService } from '../../core/services/ssr-state.service';

@Component({
    selector: 'app-invalid-url',
    templateUrl: './invalid-url.component.html',
})
export class InvalidUrlComponent implements OnInit {
    protected isUserLoggedIn = false;
    protected isClientSide = signal(false);

    constructor(
        private accountService: AccountService,
        private ssrStateService: SsrStateService
    ) {
        // Get client-side state from SSR service
        this.isClientSide = this.ssrStateService['isClientSide'];
    }

    ngOnInit(): void {
        this.checkIfUserLoggedIn();
    }

    private checkIfUserLoggedIn(): void {
        this.isUserLoggedIn = this.accountService.isAuthenticated();
    }
}
